var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"mainEl",staticClass:"jdsc-bounded-selector",class:_vm.mainClasses},[_vm._t("default",null,{"x":_vm.x,"y":_vm.y})],2)}
var staticRenderFns = []

export { render, staticRenderFns }